import React, { useEffect, useContext } from 'react';
import css from '../../../../components/UI/IdentityLoader/IdentityLoader.module.scss';
import { useApp } from '../../../../state/app';
import { useUser } from '../../../../state/user';
import {
  CreditApplicationStatus,
  useCreditClient
} from '../../../../services/credit';
import { CreditApplicationScreen } from '..';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';

interface ApplicationProcessingProps {
  setCurrentScreen: React.Dispatch<
    React.SetStateAction<CreditApplicationScreen>
  >;
}

const POLL_TIME = 30000; // milliseconds
const POLL_INTERVAL = 500; // milliseconds

export default function ApplicationProcessing({
  setCurrentScreen
}: ApplicationProcessingProps) {
  const authToken = useUser().registeredUser?.token || useApp().stargatewayKey;
  const creditClient = useCreditClient();
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Credit Application Processing');
  }, []);

  useEffect(() => {
    creditClient
      .pollApplicationStatus({
        pollTime: POLL_TIME,
        interval: POLL_INTERVAL,
        authToken
      })
      .then(status => {
        if (status === CreditApplicationStatus.APPROVED) {
          setCurrentScreen(CreditApplicationScreen.Approved);
        } else if (status === CreditApplicationStatus.REJECTED) {
          setCurrentScreen(CreditApplicationScreen.Denied);
        } else setCurrentScreen(CreditApplicationScreen.Delayed);
      });
  }, [setCurrentScreen, creditClient, authToken]);

  return (
    <div>
      <h1 data-e2e={`credit-loader-header`}>
        Processing your information. Please do not close this window.{' '}
      </h1>
      <div
        className={css.loadingContainer}
        data-e2e="credit-loading-screen"
        data-testid="credit-loader"
      >
        <img
          className={css.loadingImage}
          src={`/static/prove-loader.gif`}
          alt={`Verifying Information`}
        />
      </div>
    </div>
  );
}
